import router from '../router/router';
import axios from '../plugins/axios';

export class BrokerNetService {
    constructor() {}
    
    goToBrokerNet() {
        const vue = getVueInstance();

        const isLoggedIn = vue.$store.getters['auth/getLoginStatus'];
        if(!isLoggedIn) {
            router.push('/login');
        }
        
        axios.get('auth/broker-net')
        .then(response => {
            let win = window.open();
            let fallbackToHref = false;
            if (!win) {
                fallbackToHref = true;
            }
            if (fallbackToHref) {
              window.location.href = response.data.url;
            } else {
              win.location = response.data.url;
            }
        }).catch(error => {
            vue.$dialog.alert({
                'message': error.response.data.error.error_msg,
                'confirmButtonText': vue.$t('btn_i_understand')
            });
        });
    }
}